<ng-container class="agpr-mentionInformation" *ngIf="mention">
    <agpr-panel
        class="agpr-mentionInformation-panel"
        header="Mention.details.mentionInformation"
    >

        <div class="agpr-mentionInformation-mentionInformation-metadataWrapper">
            @for (attribute of mentionInformation; track attribute.id) {
                @if (attribute.id === mentionAttributeTypesEnum.audienceReach
                    || attribute.id === mentionAttributeTypesEnum.adValueUsd
                    || attribute.id === mentionAttributeTypesEnum.location
                    || (attribute?.value !== null && attribute?.value !== undefined)
                ) {
                    @let copyValue = attribute?.copyValue;
                    <agpr-meta-data
                        [id]="id"
                        class="agpr-mentionInformation-mentionInformation-metadata"
                        [type]="attribute.type"
                        [mediaType]="attribute.mediaType"
                        [icon]="attribute.icon"
                        [value]="attribute.value"
                        [isSimilarWeb]="attribute.isSimilarWeb"
                        [tooltip]="attribute.label"
                        [infoTooltip]="attribute.infoTooltip"
                        [isMultiline]="attribute.isMultiline"
                        [showCopyIcon]="!!attribute?.showCopyIcon && !!copyValue"
                        [copyValue]="copyValue"
                        [copyToolTip]="attribute?.copyToolTip"
                    ></agpr-meta-data>
                }
            }
        </div>
        <div *ngIf="mention.note" class="agpr-mentionInformation-notesHeading">
            {{ ('Mention.details.notes' | localize) }}
        </div>
        <section *ngIf="mention.note" class="agpr-mentionInformation-notesBody">
            <p
                class="agpr-mentionInformation-paragraph"
                *ngFor="let paragraph of notesParagraphs"
                [innerHTML]="
                    paragraph
                        | mentionLinks : mention.mediaType.id
                        | highlightKeywords:highlightKeywords
                "
            >
            </p>
        </section>
    </agpr-panel>
    @if(mentionAttributes?.length > 0) {
        <agpr-panel header="Mention.mentionOrganization">
            <ng-template #panelHeader>
                <agpr-button
                    [style]="buttonTypes.icon"
                    icon="fa-regular fa-duotone fa-gear"
                    agprTooltip="Mention.manageMentionOrganization.gearIcon.tooltip"
                    tooltipPosition="top"
                    (click)="openManageMentionOrganizationDialog()"
                ></agpr-button>
            </ng-template>
            <agpr-tags-picker
                [(ngModel)]="mention.tagIds"
                (ngModelChange)="tagsUpdated($event)"
            ></agpr-tags-picker>
            <agpr-folders-picker
                [folders]="folders"
                (addFolder)="addMentionToFolder($event)"
                (removeFolder)="removeMentionFromFolder($event)"
            ></agpr-folders-picker>
        </agpr-panel>
    }

    <agpr-panel
        *ngIf="mention.mediaType.isSocial"
        header="Mention.details.engagement"
    >
        <ng-template #panelHeader>

            <ng-container
                *ngIf="mention?.lastModifiedDate else engagementDate"
            >
                <span
                    role="img"
                    class="fa-regular fa-circle-info agpr-infoIconStyle"
                    [agprTooltip]="'Mention.details.engagement.tooltip' | localize: { dateTime: (mention.lastModifiedDate | changeTimeZone: preferences.timeZone: dateFormat) }"
                    [escape]="false"
                    tooltipPosition="right"
                ></span>
            </ng-container>

            <ng-template #engagementDate>
                <span
                    role="img"
                    class="fa-regular fa-circle-info agpr-infoIconStyle"
                    [agprTooltip]="mention?.engagementLastFetchedDate ?
                        ('Mention.details.engagement.tooltip' | localize: { dateTime: (mention.engagementLastFetchedDate | changeTimeZone: preferences.timeZone: dateFormat) })
                        : 'Mention.details.engagement.nodateTime.tooltip'"
                    [escape]="false"
                    tooltipPosition="right"
                ></span>
            </ng-template>
        </ng-template>
        <div
            *ngIf="mention?.engagements else noContent"
            class="agpr-mentionInformation-engagement-metadataWrapper"
        >
            @for (attribute of engagementInformation; track attribute.label) {
                @if (attribute.type === attributeTypesEnum.percent) {
                    <agpr-meta-data
                        class="agpr-mentionInformation-engagement-metadata"
                        [type]="attribute.type"
                        [icon]="attribute.icon"
                        [value]="(attribute.value || attribute.value === 0)
                            ? (attribute.value | number: '1.0-2')
                            : null"
                        [tooltip]="attribute.label"
                        [ariaLabel]="attribute.label"
                    ></agpr-meta-data>
                } @else {
                    <agpr-meta-data
                        class="agpr-mentionInformation-engagement-metadata"
                        [type]="attribute.type"
                        [icon]="attribute.icon"
                        [value]="(attribute.value || attribute.value === 0)
                            ? (attribute.value | number)
                            : null"
                        [tooltip]="attribute.label"
                        [ariaLabel]="attribute.label"
                    ></agpr-meta-data>
                }
            }
        </div>
        <ng-template #noContent>
            <agpr-message
                [severity]="messageSeverityEnum.noContent"
                [useWhiteBg]="true"
            >
                <span
                    [ngClass]="{
                        'agpr-mentionInformation-noContentRetweet': (mention?.tweetData?.type === tweetTypeEnum.RETWEET)
                    }"
                >
                    {{
                        (mention?.tweetData?.type === tweetTypeEnum.RETWEET) ?
                        ('Mention.details.engagement.notAvailable' | localize) :
                        ('Mention.details.engagement.noContent' | localize)
                    }}
                </span>
            </agpr-message>
        </ng-template>
    </agpr-panel>
    <agpr-panel
        *ngIf="!!mention.mentionId"
        class="agpr-mentionInformation"
        header="Mention.details.prominence"
        [clickExcludeIds]="['mentionDetails_mentionProminenceLink']"
    >
        <ng-template #panelHeader>
            <span
                role="img"
                class="fa-regular fa-circle-info agpr-infoIconStyle"
                agprTooltip="Mention.details.prominence.tooltip"
                tooltipPosition="left"
                [escape]="false"
            ></span>
            <div class="agpr-panelHeader-actionButtons">
                <a
                    id="mentionInformation_mentionProminenceLink"
                    class="fa-regular fa-duotone fa-gear"
                    tabindex="0"
                    agprTooltip="Mention.details.prominenceSettings"
                    tooltipPosition="left"
                    (click)="openProminenceTakeOverPanel($event)"
                ></a>
            </div>
        </ng-template>
        <ng-container *ngIf="hasProminenceProvision">
            <agpr-message
                *ngIf="!!prominenceStatus && prominenceStatus !== prominenceStatuses.DONE"
                [severity]="prominenceStatus === prominenceStatuses.FAILED ? messageSeverityEnum.error : messageSeverityEnum.warning"
            >
                <ng-container *ngIf="prominenceStatus === prominenceStatuses.ONGOING || prominenceStatus === prominenceStatuses.PENDING">
                    {{'AccountPreferences.prominence.disclaimer.cannotEdit' | localize}}
                </ng-container>
                <ng-container *ngIf="prominenceStatus === prominenceStatuses.FAILED">
                    {{'AccountPreferences.prominence.disclaimer.contactEngineering' | localize}}
                </ng-container>
            </agpr-message>
            <agpr-message
                *ngIf="!prominenceStatus || (prominenceStatus === prominenceStatuses.DONE && (mentionProminence?.length < 1 || mention.prominenceScores?.length < 1))"
                [useWhiteBg]="true"
                [bottomMargin]="false"
                [severity]="messageSeverityEnum.noContent"
            >
                {{'Mention.details.noProminenceInfo' | localize}}
            </agpr-message>
            <ng-container *ngIf="prominenceStatus === prominenceStatuses.DONE && mentionProminence?.length > 0">
                <agpr-attribute-list [attributes]="mentionProminence"></agpr-attribute-list>
            </ng-container>
        </ng-container>
        <ng-container *ngIf="!hasProminenceProvision">
            <agpr-message
                [severity]="messageSeverityEnum.info"
                [bottomMargin]="false"
            >
                <div [innerHTML]="'AccountPreferences.prominence.disclaimer.noProminence' | localize: { contactLink: noProminenceContactLink }"></div>
            </agpr-message>
        </ng-container>
    </agpr-panel>
    @if (mention) {
        <agpr-panel header="Mention.details.mention">
            <agpr-mention-content
                [id]="id"
                [highlightKeywords]="highlightKeywords"
                [showImageList]="!!mention"
                [useMentionCardErrorTemplate]="true"
                (outletClicked)="outletClicked.emit()"
                (contactClicked)="contactClicked.emit()"
            ></agpr-mention-content>
        </agpr-panel>
    }
    <agpr-panel
        header="Mention.workbench.insights"
        *ngIf="showInsights && !isResellerAccount"
        headerIcon="fa-kit-duotone fa-agpr-insights"
    >
        <div class="agpr-mentionInformation-createNewInsight">
            <agpr-button
                [id]="id + '_createNewInsight'"
                [style]="buttonTypes.icon"
                [icon]="'fa-regular fa-duotone fa-square-plus'"
                tooltipPosition="top"
                tooltip="Mention.insights.newInsight"
                (click)="createNewInsight()"
            >
            </agpr-button>
        </div>
        <div *ngIf="insights?.length">
            <agpr-mention-insight-card
                *ngFor="let insight of insights"
                [insight]="insight"
                (insightEdited)="updateInsight(insight)"
                (insightDeleted)="deleteInsight(insight)"
                (insightPreferred)="preferInsight(insight)"
            >
            </agpr-mention-insight-card>
        </div>

        <agpr-message
            *ngIf="!insights?.length"
            [severity]="messageSeverityEnum.noContent"
            [useWhiteBg]="true"
        >
            <span>
                {{ 'Mention.workbench.insights.noContent' | localize }}
            </span>
        </agpr-message>
    </agpr-panel>
    <agpr-panel
        class="agpr-mentionInformation"
        header="Mention.details.mentionSharing"
    >
        <agpr-content-sharing
            [id]="id + '.selectedMention'"
            *ngIf="mention.shareable"
            [content]="mention.sharingInformation"
            class="agpr-mentionContent-contentSharing"
        ></agpr-content-sharing>
        <div
            *ngIf="!mention.shareable"
            class="agpr-mentionContent-mentionNotShareable"
        >
            {{ 'Mention.details.mentionNotShareable' | localize }}
        </div>
    </agpr-panel>
    <agpr-panel
        *ngIf="mentionAttributes?.length > 0"
        class="agpr-mentionInformation"
        header="Mention.details.mentionDetails"
    >
        <agpr-attribute-list
            [attributes]="mentionAttributes"
        >
        </agpr-attribute-list>
    </agpr-panel>
</ng-container>

<ng-template let-subject #prominenceAttributeTemplate>
    <span class="agpr-prominence">
        {{subject.label}}
        <span class="agpr-prominence-label">
            {{subject.customLabel}}
            <span
                role="img"
                class="fa-regular fa-circle-info agpr-prominence-icon"
                [agprTooltip]="subject.iconToolTip.split(',') | chipTooltip : 'Mention.details.prominence.keywords'"
                tooltipPosition="top"
                [escape]="false"
            ></span>
        </span>
    </span>
</ng-template>

